import React from 'react';
export function Guarantee() {
  return <section className="py-12 px-5 bg-white" data-id="element-100">
      <div className="max-w-md mx-auto text-center" data-id="element-101">
        <div className="text-4xl mb-4" data-id="element-102">🛡️</div>
        <h2 className="text-2xl font-bold text-wine mb-4" data-id="element-103">
          Garantía 7 días — Sin preguntas
        </h2>
        <p className="text-[15px] text-dark/80 leading-relaxed mb-6" data-id="element-104">
          Abrís el sistema. Lo usás. Si en 7 días no es lo que esperabas, te
          devolvemos el 100% sin formularios, sin drama.
        </p>
        <div className="inline-block bg-sage/10 text-sage border border-sage/20 px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-105">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}